var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgLogoMobile(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 241.53 116.86",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#ea4335;}.cls-2{fill:#4285f4;}.cls-3{fill:#fbbc04;}.cls-4{fill:#0f9d58;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_2",
    "data-name": "Layer 2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Layer_1-2",
    "data-name": "Layer 1"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M57.5,58.66,96.73,36A19.3,19.3,0,0,0,77.43,2.59L9.65,41.72Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M87.06,116.86a19.3,19.3,0,0,0,9.67-36L29,41.72A19.3,19.3,0,0,0,9.65,75.15l67.78,39.12A19.14,19.14,0,0,0,87.06,116.86Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M154.48,116.86a19.17,19.17,0,0,0,9.63-2.59l67.77-39.12-47.24-17.3-39.83,23a19.3,19.3,0,0,0,9.67,36Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M222.21,77.73a19.3,19.3,0,0,0,9.67-36L164.11,2.59A19.3,19.3,0,1,0,144.81,36l67.77,39.13A19.26,19.26,0,0,0,222.21,77.73Z"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoMobile);
export default __webpack_public_path__ + "static/media/logo-mobile.eaffe7386e219102f7d1dd06640d3fa5.svg";
export { ForwardRef as ReactComponent };